<template>
  <div class="h5-container">
    <van-nav-bar
        class="top-bar"
        title="售后进度查询"
        left-text="返回"
        left-arrow
        @click-left="onClickLeft"
    ></van-nav-bar>
    <div class="container-item">
      <van-card shadow="never" class="search-card">
        <template #desc>
          <van-field
              readonly
              clickable
              name="picker"
              :value="number"
              label="球杆编码"
              placeholder="点击选择球杆编码"
              @click="showPicker = true"
              class="search-input"
          />
          <!-- 选择器弹窗：PC端适配宽度 -->
          <van-popup v-model="showPicker" position="bottom">
            <van-picker
                show-toolbar
                :columns="selectOptions"
                @confirm="onConfirm"
                @cancel="showPicker = false"
            />
          </van-popup>
        </template>
      </van-card>

      <van-button v-if="number" class="search-btn" block @click="getProgress">查询</van-button>

      <van-steps v-if="stepList.length>0" direction="vertical" :active="0" class="step-content">
        <van-step v-for="item in stepList" :key="item.id">
          <h3>{{item.code}}</h3>
          <p>{{item.send_time}}</p>
        </van-step>
      </van-steps>
    </div>
  </div>
</template>

<script>
import '@/assets/css/mobileGlobal.scss';
import {productByUser, progress} from "@/api/sales";
import {Dialog} from "vant";

export default {
  data(){
    return {
      number: '',
      selectOptions: [],
      showPicker: false,
      stepList: [],
    }
  },
  created() {
    this.selectProductByUser();
  },
  methods: {
    //顶部标题栏返回事件
    onClickLeft() {
      this.$router.push('/app_home');
    },
    //序列号确认事件
    onConfirm(value) {
      this.number = value;
      this.showPicker = false;
    },

    showDialogMsg(message){
      Dialog.alert({
        title: '查询结果',
        message: message,
        dangerouslyUseHTMLString: true,
        // PC端弹窗适配：跟随50%容器宽度
        style: { width: '90%', maxWidth: 'none' }
      });
    },
    //获取当前登录人名下注册登记的球杆
    selectProductByUser(){
      productByUser().then(res => {
        if (res.code === 200) {
          if(res.data){
            this.selectOptions = res.data.map(item => item.value);
          }
        } else {
          Dialog.alert({
            title: '提示',
            message: res.returnMsg,
            dangerouslyUseHTMLString: true,
            // PC端弹窗适配
            style: { width: '90%', maxWidth: 'none' }
          }).then(() => {
            // on close
          });
        }
      }).catch(err => {
        Dialog.alert({
          title: '错误',
          message: '获取球杆编码失败，请稍后重试',
          dangerouslyUseHTMLString: true,
          // PC端弹窗适配
          style: { width: '90%', maxWidth: 'none' }
        });
      })
    },
    // 售后进度查询
    getProgress(){
      if(!this.number){ // 优化判空逻辑
        this.showDialogMsg('请输入球杆编码');
        return;
      }
      //先清除历史数据
      this.stepList = [];
      //球杆编号
      let keyWord = this.number;
      progress(keyWord).then(res => {
        if(res.code === 200){
          const data = res.data;

          if (data.code == 0) {
            this.showDialogMsg("您所输入的球杆编码不存在，请重新输入");
            return false;
          } else if(data.code == 2){
            this.showDialogMsg(data.returnMsg);
            return false;
          } else if(data.code == 3){
            //已登记未申请售后的
            this.showDialogMsg(data.returnMsg);
            return false;
          } else if(data.code == 4){
            this.showDialogMsg(data.returnMsg);
            return false;
          }else {
            this.stepList = res.data;
          }
        }
      }).catch(err => {
        // 新增异常捕获弹窗适配
        Dialog.alert({
          title: '错误',
          message: '查询失败，请检查网络或稍后重试',
          style: { width: '90%', maxWidth: 'none' }
        });
      });
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .van-field__control{
  @media (min-width: 768px) {
    height: 60px;
    line-height: 60px;
    padding: 0 15px;
    background: #FFFFFF;
  }
}
::v-deep .van-step--vertical{
  @media (min-width: 768px) {
    line-height: 50px;
    padding: 20px 20px 0 0;
  }
}
// 容器适配：沿用公共样式50%宽度，PC端增强视觉
.h5-container {
  min-height: 100vh;
  box-sizing: border-box;
  background-color: #000;
  padding-bottom: 40px;
  // PC端样式增强
  @media (min-width: 768px) {
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.3);
    padding-bottom: 60px;
  }
}

// 导航栏样式
::v-deep .van-icon-arrow-left {
  color: #0f0f0f !important;
  // PC端放大返回箭头
  @media (min-width: 768px) {
    font-size: 24px;
  }
}
::v-deep .van-nav-bar__text {
  color: #0f0f0f !important;
  // PC端放大返回文字
  @media (min-width: 768px) {
    font-size: 18px;
  }
}
::v-deep .van-nav-bar__title {
  // PC端放大标题
  @media (min-width: 768px) {
    font-size: 22px;
    font-weight: bold;
  }
}
// 步骤条文字样式统一
::v-deep .van-step__title.van-step__title--active h3,p{
  font-weight: normal;
  // PC端放大步骤条文字
  @media (min-width: 768px) {
    font-size: 16px;
  }
}
::v-deep .van-step__title h3,p{
  font-weight: normal;
  // PC端放大步骤条文字
  @media (min-width: 768px) {
    font-size: 16px;
  }
}
::v-deep .van-step__title p{
  padding-top: 5px;
  // PC端调整步骤条时间间距
  @media (min-width: 768px) {
    padding-top: 8px;
    font-size: 14px;
    color: #666;
  }
}
// PC端步骤条整体样式优化
::v-deep .van-steps--vertical {
  @media (min-width: 768px) {
    padding: 10px 20px;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }
}
::v-deep .van-step__icon {
  @media (min-width: 768px) {
    width: 24px;
    height: 24px;
    font-size: 14px;
  }
}
::v-deep .van-step__line {
  @media (min-width: 768px) {
    width: 2px;
  }
}

// 导航栏背景
.top-bar{
  background: linear-gradient(135deg, #D4AF37 0%, #B8860B 100%);
  // PC端增高导航栏
  @media (min-width: 768px) {
    height: 70px;
    line-height: 70px;
  }
}

// 主容器适配
.container-item {
  padding: 0 16px;
  margin-bottom: 60px;
  box-sizing: border-box;
  width: 100%;
  // PC端调整间距和内边距
  @media (min-width: 768px) {
    padding: 0 20px;
    margin-bottom: 80px;
  }
}

// 搜索卡片适配
.search-card {
  margin: 16px 0;
  border-radius: 12px;
  height: 200px;
  background-image: url('~@/assets/img/h5/step_bk.png');
  background-size: cover; /* 背景图覆盖整个容器 */
  background-repeat: no-repeat; /* 不重复显示 */
  background-position: center center; /* 背景图居中显示 */
  box-sizing: border-box;
  width: 100%;
  // PC端卡片优化
  @media (min-width: 768px) {
    margin: 20px 0;
    border-radius: 16px;
    height: 460px; // 增高卡片适配宽屏背景图
    background-size: cover;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }
}

// 搜索输入框适配
.search-input{
  margin-top: 160px;
  border-radius: 10px;
  border-bottom: none;
  background: linear-gradient(135deg, #D4AF37 0%, #B8860B 100%);
  // PC端输入框优化
  @media (min-width: 768px) {
    margin-top: 380px; // 适配增高后的卡片
    border-radius: 12px;
    height: 60px;
    // 输入框内容样式
    ::v-deep .van-field__label {
      font-size: 18px;
      color: #000;
      font-weight: bold;
      width: 100px;
      line-height: 60px;
    }
    ::v-deep .van-field__value {
      font-size: 16px;
      color: #000;
    }
    ::v-deep .van-field__placeholder {
      font-size: 16px;
      color: #FFFFFF;
    }
    // PC端输入框hover效果
    cursor: pointer;
    &:hover {
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
      transition: all 0.2s ease;
    }
  }
}

// 查询按钮适配
.search-btn {
  width: 100%;
  height: 48px;
  border-radius: 10px;
  background: linear-gradient(135deg, #D4AF37 0%, #B8860B 100%);
  color: #000;
  font-size: 16px;
  font-weight: bold;
  border: none;
  margin-bottom: 16px;
  margin-top: 32px;
  box-sizing: border-box;
  // PC端按钮优化
  @media (min-width: 768px) {
    height: 60px;
    border-radius: 12px;
    font-size: 18px;
    margin-top: 40px;
    margin-bottom: 20px;
    // PC端hover效果
    cursor: pointer;
    &:hover {
      background: #B8860B;
      transform: scale(1.02);
      transition: all 0.2s ease;
    }
    // 禁用状态hover重置
    &:disabled {
      cursor: not-allowed;
      background: linear-gradient(135deg, #D4AF37 0%, #B8860B 100%);
      transform: none;
      opacity: 0.7;
    }
  }
}

// 步骤条容器适配
.step-content{
  padding-bottom: 16px;
  border-radius: 10px;
  width: 100%;
  box-sizing: border-box;
  // PC端步骤条容器优化
  @media (min-width: 768px) {
    padding-bottom: 20px;
    border-radius: 12px;
    margin-top: 20px;
  }
}

// PC端选择器弹窗适配
:deep(.van-popup) {
  @media (min-width: 768px) {
    width: 100% !important;
  }
}
:deep(.van-picker) {
  @media (min-width: 768px) {
    width: 100%;
    font-size: 16px;
    height: 300px;
  }
}
:deep(.van-picker__toolbar) {
  @media (min-width: 768px) {
    font-size: 18px;
  }
}
</style>